module.exports = __webpack_public_path__ + "static/media/icon_no_data.61421c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_no_data.png
// module id = 2164
// module chunks = 0